import "./index.css";
import axios from "axios";
import App from "./App";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import moment from "moment";
import "moment/locale/fr";
import "moment/locale/es";
import "moment/locale/it";
import "moment/locale/ru";
import "moment/locale/en-gb";

let lang = "en";

axios.defaults.baseURL = "https://api.themoviedb.org/3/";
axios.defaults.params = {
  api_key: "6411cdf86812f3aa034a00c5987adb76",
  language: lang || "en"
};
moment.locale(lang || "en");

window.app_name = "Watch";

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js